import { Fragment, memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { ElasticModal } from 'basic-components';

import Row from './Row';

import { When } from 'react-if';

import './InfoModal.scss';

const emptyArray = []
const InfoModal = ({ index, onClose }) => {
  const selectedSymbols = useSelector(state => state.seriesState.creatorState.selectedSymbols) || emptyArray,
        symbol = useMemo(() => selectedSymbols[index], [index, selectedSymbols]),
        isPattern = useMemo(() => symbol.pattern === "true" || symbol.pattern === undefined, [symbol])

  return (
    <ElasticModal
        className="ng-office-app__authed__content__basket__info-modal"
        onClose={onClose}
        open
        optionalText={isPattern ? undefined : `In group: ${symbol.groupName}`}
        title={isPattern ? "Pattern information" : "Symbol information"}
    >
      <When condition={Object.keys(symbol?.symbols || {}).length > 0}>
        {() => (
          <Fragment>
            <div className="ng-office-app__authed__content__basket__info-modal__header">
              Keys:
            </div>
            {Object.entries(symbol?.symbols || {}).map(([key, value]) => (
              <Row
                  key={`info_modal_symbol_row_${key}_${value}`}
                  label={key}
                  value={value}
              />
            ))}
          </Fragment>
        )}
      </When>
      <When condition={Object.keys(symbol?.metadata || {}).length > 0}>
        {() => (
          <Fragment>
            <div className="ng-office-app__authed__content__basket__info-modal__header">
              Metadata:
            </div>
            {Object.entries(symbol?.metadata || {}).map(([key, value]) => (
              <Row
                  key={`info_modal_md_row_${key}_${value}`}
                  label={key}
                  value={value}
              />
            ))}
          </Fragment>
        )}
      </When>
      <When condition={(isPattern && (!!symbol?.query || !!symbol?.groupName)) || !!symbol?.source}>
        {() => (
          <Fragment>
            <div className="ng-office-app__authed__content__basket__info-modal__header">
              Details:
            </div>
            <When condition={isPattern && !!symbol?.query}>
              {() => (
                <Row
                    key={`info_modal_details_row_query_${symbol.query}`}
                    label="Keyword"
                    value={symbol.query}
                />
              )}
            </When>
            <When condition={isPattern && !!symbol?.groupName}>
              {() => (
                <Row
                    key={`info_modal_details_row_group_name_${symbol.groupName}`}
                    label="Group name"
                    value={symbol.groupName}
                />
              )}
            </When>
            <When condition={!!symbol?.source}>
              {() => (
                <Row
                    key={`info_modal_details_row_group_name_${symbol.groupName}`}
                    label="Source"
                    value={symbol.source}
                />
              )}
            </When>
          </Fragment>
        )}
      </When>
    </ElasticModal>
  )
}

InfoModal.propTypes = {
  index: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default memo(InfoModal);